<form class="" [formGroup]="PainManagementForm">
  <div class="row g-3 mb-3 align-items-end">
    <div class="col-md-6">
      <div class="form-floating my-2" id="nextPainApptDiv">
        <input type="date" class="form-control" id="nextPainAppt" formControlName="nextPainAppt" placeholder="Next Pain Appointment" />
        <label for="nextPainAppt">Next Pain Appointment</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-check mb-4">
        <input class="form-check-input" type="checkbox" id="painPRN" formControlName="painPRN" />
        <label class="form-check-label" for="painPRN"> Pain PRN </label>
      </div>
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-md-4" *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
      <div class="form-floating" id="painFU{{ item }}Div">
        <input type="date" class="form-control" id="painFU{{ item }}" formControlName="painFU{{ item }}" placeholder="Pain FU {{ item }}" />
        <label for="painFU{{ item }}">Pain FU {{ item }}</label>
      </div>
    </div>
  </div>

  <hr class="my-4" />

  <div class="row align-items-end g-3 mb-3">
    <div class="col-md-12">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="surgeryRx" formControlName="surgeryRx" />
        <label class="form-check-label" for="surgeryRx"> SurgeryRX </label>
      </div>
    </div>
    <div class="col-md-4" *ngFor="let item of [1, 2]">
      <div class="form-floating mb-3" id="surgeryDateDiv">
        <input type="date" class="form-control" id="surgeryDate{{ item }}" placeholder="surgeryDate " formControlName="surgeryDate{{ item }}" />
        <label for="surgeryDate{{ item }}">Surgery Date {{ item }}</label>
      </div>
      <div class="form-check mb-3" id="surgeryPerfomedDiv">
        <input class="form-check-input" type="checkbox" id="surgeryPerfomed{{ item }}" formControlName="surgeryPerfomed{{ item }}" />
        <label class="form-check-label" for="surgeryPerfomed{{ item }}"> Surgery Performed {{ item }}? </label>
      </div>
      <div class="form-check mb-4">
        <input class="form-check-input" type="checkbox" id="nextSurgery{{ item }}" formControlName="nextSurgery{{ item }}" />
        <label class="form-check-label" for="nextSurgery{{ item }}"> Next Surgery? </label>
      </div>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
  <button type="button" class="btn btn-primary" (click)="isData ? updatePainAppointment() : makePainAppoinment()" [disabled]="patientData.isDischarged">
    {{ isData ? 'Update' : 'Create' }} Appointment
  </button>
</div>
